import React from 'react';
import StatusModule from './StatusModule';
import { StatusContainer, StatusHeaderStyle, ModuleListContainer } from './StatusModuleList.css.js';
import { titleInitial } from 'utils/code';

const StatusModuleList = (props) => {
  return (
    <StatusContainer>
      <StatusHeaderStyle status={props.totalStatus}>
        <div className="titleInitial">G</div>
        <div>{props.title} 현황</div>
        <img src="" alt="mainInfo_Icon" />
      </StatusHeaderStyle>
      <div className="statusDetailBox">
        <ModuleListContainer modulesCount={props.log.length}>
          {props.log.map((data) => {
            return <StatusModule key={data.moduleIdx} {...data} status={data.statusCode === '1' && data.status !== 'none' ? 'blue' : data.status} />;
          })}
        </ModuleListContainer>
      </div>
    </StatusContainer>
  );
};

export default React.memo(StatusModuleList);
